'use client';
import ScreeningHitsWorkflow from './components/ScreeningHitsWorkflow';

export default function ScreeningHitsPage() {
  return <ScreeningHitsWorkflow />;
}
